const allNavigationsMap = {
  "getting-started": {
    link: "/docs/getting-started/introduction",
    name: "Getting Started",
    items: [
      {
        introduction: {
          name: "Introduction",
          link: "/docs/getting-started/introduction",
          nextLink: "/docs/getting-started/interface-overview",
          nextText: "Interface Overview",
        },
      },
      {
        "interface-overview": {
          name: "Interface Overview",
          link: "/docs/getting-started/interface-overview",
          prevLink: "/docs/getting-started/introduction",
          prevText: "Introduction",
          nextLink: "/docs/test-plans/test-plan",
          nextText: "Managing Test Plans",
        },
      },
    ],
  },
  "automation": {
    link: "/docs/automation/ai-automation",
    name: "AI Automation",
    items: [
      {
        "ai-automation": {
          name: "Ai Automation",
          link: "/docs/automation/ai-automation",
          prevLink: "/docs/generate-ai/ai-suggest",
          prevText: "Suggestions from AI",
          nextLink: "/docs/test-plans/test-plant",
          nextText: "Managing Test Plans",
        },
      },
      
    ],
  },
  "generate-ai": {
    link: "/docs/generate-ai/getting-started-with-ai",
    name: "Generate AI",
    items: [
      {
        "getting-started-with-ai": {
          name: "Generating Test Plan",
          link: "/docs/generate-ai/getting-started-with-ai",
          prevLink: "/docs/apis/error-handling",
          prevText: "Error Handling",
          nextLink: "/docs/generate-ai/ai-suggest",
          nextText: "Suggestions from AI",
        },
      },
      {
        "importing-test-cases": {
          name: "Importing Test Cases",
          link: "/docs/test-plans/importing-test-cases",
          prevLink: "/docs/test-plans/test-plan",
          prevText: "Managing Test Plans",
          nextLink: "/docs/executing-test-runs/customize-test-runs",
          nextText: "Create Test Runs",
        },
      },
    ],
  },
  "test-plans": {
    link: "/docs/test-plans/test-plan",
    name: "Test Plans",
    items: [
      {
        "test-plan": {
          name: "Managing Test Plans",
          link: "/docs/test-plans/test-plan",
          prevLink: "/docs/getting-started/interface-overview",
          prevText: "Interface Overview",
          nextLink: "/docs/test-plans/importing-test-cases",
          nextText: "Importing Test Cases",
        },
      },
      {
        "importing-test-cases": {
          name: "Importing Test Cases",
          link: "/docs/test-plans/importing-test-cases",
          prevLink: "/docs/test-plans/test-plan",
          prevText: "Managing Test Plans",
          nextLink: "/docs/executing-test-runs/customize-test-runs",
          nextText: "Create Test Runs",
        },
      },
    ],
  },
  "executing-test-runs": {
    name: "Executing Test Runs",
    link: "/docs/executing-test-runs/customize-test-runs",
    items: [
      {
        "customize-test-runs": {
          name: "Create Test Runs",
          link: "/docs/executing-test-runs/customize-test-runs",
          prevLink: "/docs/test-plans/importing-test-cases",
          prevText: "Importing Test Cases",
          nextLink: "/docs/executing-test-runs/updating-test-runs",
          nextText: "Updating Test Run",
        },
      },
      {
        "updating-test-runs": {
          name: "Updating Test Run",
          link: "/docs/executing-test-runs/updating-test-runs",
          prevLink: "/docs/executing-test-runs/customize-test-runs",
          prevText: "Create Test Runs",
          nextLink: "/docs/executing-test-runs/assigning-test-cases",
          nextText: "Assign Test Cases",
        },
      },
      {
        "assigning-test-cases": {
          name: "Assign Test Cases",
          link: "/docs/executing-test-runs/assigning-test-cases",
          prevLink: "/docs/executing-test-runs/updating-test-runs",
          prevText: "Updating Test Run",
          nextLink: "/docs/test-results-and-analytics/reviewing-test-results",
          nextText: "Reviewing test results",
        },
      },
    ],
  },
  "test-results-and-analytics": {
    link: "/docs/test-results-and-analytics/reviewing-test-results",
    name: "Test Results and Analytics",
    items: [
      {
        "reviewing-test-results": {
          name: "Reviewing test results",
          link: "/docs/test-results-and-analytics/reviewing-test-results",
          prevLink: "/docs/executing-test-runs/assigning-test-cases",
          prevText: "Assign Test Cases",
          nextLink: "/docs/test-results-and-analytics/analyzing-test-analytics",
          nextText: "Analyzing Test Analytics",
        },
      },
      {
        "analyzing-test-analytics": {
          name: "Analyzing Test Analytics",
          link: "/docs/test-results-and-analytics/analyzing-test-analytics",
          prevLink: "/docs/test-results-and-analytics/reviewing-test-results",
          prevText: "Reviewing test results",
          nextLink: "/docs/sharing-test-plans/sharing-test-plans",
          nextText: "Sharing Test plans",
        },
      },
    ],
  },
  "sharing-test-plans": {
    link: "/docs/sharing-test-plans/sharing-test-plans",
    name: "Share and Collab",
    items: [
      {
        "sharing-test-plans": {
          name: "Sharing Test plans",
          link: "/docs/sharing-test-plans/sharing-test-plans",
          prevLink: "/docs/test-results-and-analytics/analyzing-test-analytics",
          prevText: "Analyzing Test Analytics",
          nextLink: "/docs/sharing-test-plans/merging-projects",
          nextText: "Merging Projects",
        },
      },
      {
        "merging-projects": {
          name: "Merging Projects",
          link: "/docs/sharing-test-plans/merging-projects",
          prevLink: "/docs/sharing-test-plans/sharing-test-plans",
          prevText: "Sharing Test plans",
          nextLink: "/docs/sharing-test-plans/inviting-team-members",
          nextText: "Inviting Team Members",
        },
      },
      {
        "inviting-team-members": {
          name: "Inviting Team Members",
          link: "/docs/sharing-test-plans/inviting-team-members",
          prevLink: "/docs/sharing-test-plans/merging-projects",
          prevText: "Merging Projects",
          nextLink: "/docs/project-settings/project-settings",
          nextText: "Project Settings",
        },
      },
    ],
  },
  "project-settings": {
    link: "/docs/project-settings/project-settings",
    name: "Project Settings",
    items: [
      {
        "project-settings": {
          name: "Project Settings",
          link: "/docs/project-settings/project-settings",
          prevLink: "/docs/sharing-test-plans/inviting-team-members",
          prevText: "Inviting Team Members",
          nextLink: "/apis/api-overview",
          nextText: "APIs Overview",
        },
      },
    ],
  },
  apis: {
    link: "/apis/api-overview",
    name: "APIs",
    items: [
      {
        "api-overview": {
          name: "APIs Overview",
          link: "/apis/api-overview",
          prevLink: "/docs/project-settings/project-settings",
          prevText: "Project Settings",
          nextLink: "/apis/auth-using-api",
          nextText: "API Authentication",
        },
      },
      {
        "auth-using-api": {
          name: "API Authentication",
          link: "/apis/auth-using-api",
          prevLink: "/apis/api-overview",
          prevText: "APIs Overview",
          nextLink: "/apis/project-management",
          nextText: "Project Management API",
        },
      },
      {
        "project-management": {
          name: "Project Management API",
          link: "/apis/project-management",
          prevLink: "/apis/auth-using-api",
          prevText: "API Authentication",
          nextLink: "/apis/managing-test-suites",
          nextText: "Managing Test Cases",
        },
      },
      {
        "managing-test-suites": {
          link: "/apis/managing-test-suites",
          name: "Managing Test Cases",
          prevLink: "/apis/project-management",
          prevText: "Project Management API ",
          nextLink: "/apis/test-run",
          nextText: "Test Run API",
        },
      },
      {
        "test-run": {
          link: "/apis/test-run",
          name: "Test Run API",
          prevLink: "/apis/managing-test-suites",
          prevText: "Managing Cases",
          nextLink: "/apis/update-test-case",
          nextText: "Update Test Case Status",
        },
      },
      {
        "update-test-case": {
          name: "Update Test Case Status",
          link: "/apis/update-test-case",
          prevLink: "/apis/test-run",
          prevText: "Test Run API",
          nextLink: "/apis/error-handling",
          nextText: "Error Handling",
        },
      },
      {
        "error-handling": {
          name: "Error Handling",
          link: "/apis/error-handling",
          prevLink: "/apis/update-test-case",
          prevText: "Update Test Case Status",
          nextLink: "/docs/integrations/integration-overview",
          nextText: "Integration Overview",
        },
      },
    ],
  },
  integrations: {
    link: "/docs/integrations/integration-overview",
    name: "Integrations",
    items: [
      {
        "integration-overview": {
          name: "Integration Overview",
          link: "/docs/integrations/integration-overview",
          prevLink: "/apis/error-handling",
          prevText: "Error Handling",
          nextLink: "/docs/integrations/github-integration",
          nextText: "Github Integration",
        },
      },
      {
        "github-integration": {
          name: "Github Integration",
          link: "/docs/integrations/github-integration",
          prevLink: "/docs/integrations/integration-overview",
          prevText: "Integration Overview",
          nextLink: "/docs/integrations/jira-integration",
          nextText: "Jira Integration",
        },
      },
      {
        "jira-integration": {
          name: "Jira Integration",
          link: "/docs/integrations/jira-integration",
          prevLink: "/docs/integrations/github-integration",
          prevText: "Github Integration",
          nextLink: "/docs/integrations/asana-integration",
          nextText: "Asana Integration",
        },
      },
      {
        "asana-integration": {
          name: "Asana Integration",
          link: "/docs/integrations/asana-integration",
          prevLink: "/docs/integrations/jira-integration",
          prevText: "Jira Integration",
          nextLink: "/docs/integrations/trello-integration",
          nextText: "Trello Integration",
        },
      },
      {
        "trello-integration": {
          name: "Trello Integration",
          link: "/docs/integrations/trello-integration",
          prevLink: "/docs/integrations/asana-integration",
          prevText: "Asana Integration",
          nextLink: "/docs/cicd/cicd-automation",
          nextText: "CI/CD Automation",
        },
      },
    ],
  },
  cicd: {
    link: "/docs/cicd/cicd-automation",
    name: "CI/CD Automation",
    items: [
      {
        "cicd-automation": {
          name: "CI/CD Automation",
          link: "/docs/cicd/cicd-automation",
          prevLink: "/docs/integrations/trello-integration",
          prevText: "Trello Integration",
          nextLink: "/docs/cicd/integrating-jenkins",
          nextText: "Integrating Jenkins",
        },
      },
      {
        "integrating-jenkins": {
          name: "Integrating Jenkins",
          link: "/docs/cicd/integrating-jenkins",
          prevLink: "/docs/cicd/cicd-automation",
          prevText: "CI/CD Automation",
          nextLink: "/docs/cicd/integrating-circleci",
          nextText: "Integrating CircleCI",
        },
      },
      {
        "integrating-circleci": {
          name: "Integrating CircleCI",
          link: "/docs/cicd/integrating-circleci",
          prevLink: "/docs/cicd/integrating-jenkins",
          prevText: "Integrating Jenkins",
          nextLink: "/docs/cicd/integrating-bitbucket",
          nextText: "Integrating BitBucket",
        },
      },
      {
        "integrating-bitbucket": {
          name: "Integrating BitBucket",
          link: "/docs/cicd/integrating-bitbucket",
          prevLink: "/docs/cicd/integrating-circleci",
          prevText: "Integrating CircleCI",
          nextLink: "/docs/cicd/integrating-travisci",
          nextText: "Integrating Travis CI",
        },
      },
      {
        "integrating-travisci": {
          name: "Integrating TravisCI",
          link: "/docs/cicd/integrating-travisci",
          prevLink: "/docs/cicd/integrating-bitbucket",
          prevText: "Integrating BitBucket",
        },
      },
    ],
  },
};
// const item = allNavigationsMap["getting-started"].items.find(
//   (item) => item["introduction"]
// );
// console.log(item["introduction"].name);

// const searchDocs = (searchTerm) => {
//   const lowerCaseTerm = searchTerm.toLowerCase();
//   const results = [];

//   Object.keys(allNavigationsMap).forEach((docType) => {
//     const section = allNavigationsMap[docType];

//     // Check if the section has a name before attempting to access it
//     if (section.name && section.name.toLowerCase().includes(lowerCaseTerm)) {
//       results.push(results.push(nameItem));
//     }

//     // Check if the section has items before looping through them
//     if (section.items) {
//       section.items.forEach((item) => {
//         const key = Object.keys(item)[0];
//         const nameItem = item[key];

//         if (nameItem.name.toLowerCase().includes(lowerCaseTerm)) {
//           results.push(nameItem);
//         }
//       });
//     }
//   });

//   return results;
// };

// Example usage:
// const searchTerm = "interface"; // Or "Getting Started"
// const searchResults = searchDocs(searchTerm);
// console.log(searchResults);

export default allNavigationsMap;
